import { SET_HEADER_NAVIGATION_DISABLED } from '@/store/mutation.types';

export default {
    state: () => ({
        navigationDisabled: false
    }),

    actions: {
        setHeaderNavigationDisabled: ({ commit }, navigationDisabled) => {
            commit(SET_HEADER_NAVIGATION_DISABLED, navigationDisabled);
        }
    },

    mutations: {
        [SET_HEADER_NAVIGATION_DISABLED]: (state, navigationDisabled) => {
            state.navigationDisabled = navigationDisabled;
        }
    }
};
